import { h, Component } from 'preact';
import { database, config, auth } from '../../firebaseConfig';
import { assign } from 'lodash';
import moment from 'moment';

import TextField from 'preact-material-components/TextField';
import Button from 'preact-material-components/Button';
import Checkbox from 'preact-material-components/Checkbox';
import Formfield from 'preact-material-components/FormField';

const currency = number => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(number);

export default class Form extends Component {
	state = {
		amount: '',
		description: '',
		completed: false,
		referenceDate: moment().format('YYYY-MM'),
		user: null
	};

	constructor(props) {
		super(props);
		
		this.save = this.save.bind(this);
		this.removePayment = this.removePayment.bind(this);
	}

	componentWillMount() {
		const { firebaseId } = this.props;

		this.setState({ user: auth.currentUser })

		if (firebaseId) {
			this.payments = database.ref(`${config.databaseName}/${firebaseId}`);

			this.payments.on('value', snapshot => {
				this.setState({ ...snapshot.val() });
			});
		} else {
			this.payments = database.ref(config.databaseName);
		}
	}

	setForm(prop) {
		return ev => {
			this.setState({ [prop]: ev.target.value });
		};
	}

	setAmount = (ev) => {
		let amount = String(ev.target.value).replace(/\D+/gi, '');
		amount = amount.replace(/(\d+)(\d{2})$/ig, '$1.$2');

		this.setState({ amount });
	}

	isFormInvalid() {
		return !this.state.description ||
      !this.state.amount ||
      !this.state.referenceDate;
	}

	removePayment(evt) {
		evt.preventDefault();

		this.payments.remove();
		this.props.onFinish();
	}

	markCompleted = (evt) => {
		this.setState({ completed: evt.target.checked });
	}

	save(ev) {
		ev.preventDefault();
		
		const { user, firebaseId } = this.props;
		let _payments;

		let data = {
			email: user.email,
			description: this.state.description.toUpperCase(),
			amount: this.state.amount,
			amountFormated: currency(this.state.amount),
			referenceDate: this.state.referenceDate,
			completed: this.state.completed,
			updatedAt: new Date().toJSON()
		};

		if (firebaseId) {
			this.payments.update(data);
		}else {
			_payments = this.payments.push();
			data = assign(data, { createdAt: new Date().toJSON(), firebaseId: _payments.key });
			_payments.set(data);
		}

		this.setState({
			description: '',
			amount: '',
			referenceDate: ''
		});

		this.props.bar.MDComponent.show({
			message: 'Pagamento salvo com sucesso!'
		});

		this.props.onFinish();
	}

	render(props, state) {
		let { description, amount, referenceDate } = state;
		const { firebaseId } = props;

		const className = props.className || '';

		return (
			<form onSubmit={this.save} className={`w-75-l w-100 pa2 flex flex-column justify-center items-center ${className}`}>
				{ !firebaseId ? (
					<p className="flex flex-column justify-center items-center tc">
						<span className="b dark-gray pa1 f2">Adicionar um pagamento, é fácil e rápido.</span>
						<span className="pa1 mt4 moon-gray">* É importante preencher todos os campos</span>
					</p>
				) : null }

				<div className="pa2 mv2 w-100 flex justify-center items-center flex-column">
					<TextField
						label="Descrição"
						value={description}
						onChange={this.setForm('description')}
						className="input-container uppercase"
						outlined
						helperText="Insira uma descrição"
						helperTextPersistent
					/>
          
					<TextField
						type="text"
						value={amount}
						onInput={this.setAmount}
						label="Valor R$"
						className="input-container"
						outlined
						helperText="Qual o valor do pagamento?"
						helperTextPersistent
					/>
          
					<TextField
						outlined
						type="month"
						label="Data Pagamento"
						value={referenceDate}
						onInput={this.setForm('referenceDate')}
						className="input-container"
						helperText="Qual o data do pagamento?"
						helperTextPersistent
					/>

					<Formfield>
						<Checkbox checked={this.state.completed} name="completed" id="completed" onClick={this.markCompleted} ref={cb => { this.cb = cb; }}/>
						<label for="completed" id="completed-label">Pagamento efetuado?</label>
					</Formfield>
				</div>

				<div className="flex justify-between h-25 items-center mt3 flex-column">
					<Button ripple raised secondary disabled={this.isFormInvalid()}>
						Salvar Pagamento
					</Button>

					{ firebaseId ? (
						<Button className="bg-black" ripple onClick={this.removePayment}>
							Excluir Pagamento
						</Button>
					) : null}
				</div>
			</form>
		);
	}
}



// WEBPACK FOOTER //
// ./components/form/index.js